import QUERY from '@/api_app/set'
import { Toast } from 'vant';

const getDefaultState = () => {
  return {
    GetSetData : {list:[]},
  }
}

const state = getDefaultState()

const mutations = {
  SET_DATA: (state, {key,data}) => {
    state[key] = data;
  },
}

const actions = {
    // 获取设置页的用户信息
  GetSetData({ commit }, params) {
    return new Promise((resolve, reject) => {
      QUERY({ key:'GetSetData' ,params}).then(response => {
        const { data } = response
        if(data.code!=1000){
          Toast(data.message)
        }else{
          commit('SET_DATA',{ key:'GetSetData', data:data })
        }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
//   获取可切换的店铺列表
  GetSetList({ commit }, params) {
    return new Promise((resolve, reject) => {
      QUERY({ key:'GetSetList' ,params}).then(response => {
        const { data } = response
        if(data.code!=1000){
          Toast(data.message)
        }else{
          commit('SET_DATA',{ key:'GetSetList', data:data })
        }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  //   切换店铺
  ChangeStroe({ commit }, params) {
      return new Promise((resolve, reject) => {
        QUERY({ key:'ChangeStroe' ,params}).then(response => {
          const { data } = response
          if(data.code!=1000){
            Message.error(data.message)
          }else{
            commit('SET_DATA',{ key:'ChangeStroe', data:data })
          }
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

